import React, { useEffect } from 'react';
import { MenuItem } from 'material-ui';
import BasicSelector from '../../TcIndex/Basic/BasicSelector';
import { HIRE_TYPES_MAP } from 'constants/hire';

function HireType({
    hireType, countIndex, changeFieldsMultiple, setHasErrors, required, 
}) {
    useEffect(() => {
        if (required) {
            if (!hireType) {
                setHasErrors('hireType', true);
            } else {
                setHasErrors('hireType', false);
            }
        }
    }, [hireType]);
    
    const selectVesselType = (value) => {
        changeFieldsMultiple([
            {
                index: countIndex,
                field: 'hireType',
                value,
            },
        ]);
    };

    return (
        <BasicSelector 
            value={hireType}
            dataList={HIRE_TYPES_MAP}
            onChange={(e, _i, value) => selectVesselType(value)}
            iconStyle={{ display: 'none' }}
            underlineStyle={{ display: 'none' }}
            style={{ fontSize: '10px' }}
            labelStyle={{ padding: 0, top: 'unset' }}
            fields={['placeHolder']}
            customRender={
                HIRE_TYPES_MAP
                    .map(item => (<MenuItem 
                        key={item.field}
                        value={item.field}
                        primaryText={item.placeHolder}
                    />))
            }
        />  
    );
}

export default React.memo(HireType);



// WEBPACK FOOTER //
// ./app/components/Hires/rowData/HireType.jsx